import * as types from "../action/types";

const initialState = {
  company: null,
};

export const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'AVPS_TEMPLATE_PREVIEW_COMPANY':
      return {
        ...state,
        company: Array.isArray(action.payload) ? action.payload[0] : action.payload,
      };

    case types.FETCH_COMPANY_DETAILS_SUCCESS:
      const companyData = Array.isArray(action.payload)
        ? action.payload[0]
        : action.payload;
      return {
        ...state,
        company: companyData,
      };

    default:
      return state;
  }
};

export default companyReducer;
